<ion-header>
  <ion-toolbar>
    <ion-title>Officials</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    @for (official of match.officials; let i  = $index; track i;) {
      <ion-item>
        <ion-label>
          <ion-text>
            {{ getOfficialName(official) }}
            <p>{{ official.type | translate }}</p>
          </ion-text>
        </ion-label>

        <ion-button size="default" slot="end" color="danger" fill="clear" (click)="removeAssignedOfficial(official, i)">
          <ion-icon slot="icon-only" name="trash"></ion-icon>
        </ion-button>

      </ion-item>
    }
  </ion-list>

  @if (!match?.officials?.length) {
    <app-empty-page text="There are no officials assigned to this match" iconName="people"></app-empty-page>
  }

  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button (click)="isAssignModalOpen = true">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>

  <ion-modal

    [isOpen]="isAssignModalOpen"
    (ionModalDidDismiss)="isAssignModalOpen = false">
    <ng-template>
      <ion-header>
        <ion-toolbar>
          <ion-title>Assign official</ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="isAssignModalOpen = false">
              <ion-icon slot="start" name="close"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>

      <ion-content>
        <ion-list>
          <form [formGroup]="assignOfficialForm">

            <ion-item button (click)="getOfficial()" details="false">
              <ion-label position="stacked">Official</ion-label>
              <ion-text>
                @if (official) {
                  {{ official.user.first_name }} {{ official.user.last_name }}
                } @else {
                  Select official
                }
              </ion-text>

            </ion-item>

            <ion-item>
              <ion-select label="Venue" interface="popover" placeholder="Select venue" formControlName="venue">
                @for (venue of tournament.venues; track $index) {
                  <ion-select-option [value]="venue">{{ venue.venueAbbreviation }}</ion-select-option>
                }
              </ion-select>
            </ion-item>

            <ion-item>
              <ion-select label="Court" interface="popover" placeholder="Select venue" formControlName="court">
                @for (court of courts$ | async; track $index) {
                  <ion-select-option [value]="court">{{ court.courtName }}</ion-select-option>
                }
              </ion-select>
            </ion-item>

            @if (assignOfficialForm.controls.court.value?.devices.length) {
              <ion-list-header>
                <ion-label>Integrations</ion-label>
              </ion-list-header>

              @for (device of assignOfficialForm.controls.court.value?.devices; track $index) {
                <ion-item>
                  <ion-toggle label-placement="start" (ionChange)="selectDevices($event, device)">{{ device.name }} ({{device.partner }})</ion-toggle>
                </ion-item>
              }
            }

            @if (assignOfficialForm.controls.court.value?.videoBoards.length) {
              <ion-list-header>
                <ion-label>Video Boards</ion-label>
              </ion-list-header>

              @for (videoBoard of assignOfficialForm.controls.court.value?.videoBoards; track $index) {
                <ion-item>
                  <ion-toggle label-placement="start" (ionChange)="selectVideoBoards($event, videoBoard._id)">{{ videoBoard.name }}</ion-toggle>
                </ion-item>
              }
            }

            <ion-button class="ion-margin" (click)="submit()" expand="block">
              Assign
            </ion-button>

            <ion-button class="ion-margin" (click)="isAssignModalOpen = false" expand="block" fill="clear">
              Close
            </ion-button>
          </form>
        </ion-list>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>